import { useRunPayrollDataContext } from 'components/RunPayroll/contexts/RunPayrollDataContext';
import { useCanViewComplianceActions } from 'components/RunPayroll/ComplianceActions/hooks/useCanViewComplianceActions';
import { useQuery } from 'react-query';
import { GET_COMPLIANCE_ACTIONS } from 'components/RunPayroll/ComplianceActions/queries';
import api from 'api';
import {
  complianceActionsMap,
  runPayrollActionCompletedStatuses,
} from 'components/RunPayroll/ComplianceActions/data';
import { AppError } from 'components/AppError';

export const useGetComplianceActionDetails = () => {
  const canViewComplianceActions = useCanViewComplianceActions();
  const runPayrollDataContext = useRunPayrollDataContext();

  const payrollMonth = runPayrollDataContext?.payrollMonth;
  const skipApiCall = !canViewComplianceActions || !payrollMonth;

  const complianceActionsQueryResponse = useQuery(
    [GET_COMPLIANCE_ACTIONS, payrollMonth],
    () => {
      return payrollMonth
        ? api.complianceActions.getComplianceActions(payrollMonth)
        : Promise.reject('Payroll Month is required');
    },
    {
      onError: (error: typeof AppError) => {
        //do nothing
      },
      enabled: !skipApiCall,
      refetchOnMount: false,
    },
  );

  const actionsApiResponse = complianceActionsQueryResponse?.data?.actions;
  const isKaptPaymentWindowOpen =
    complianceActionsQueryResponse?.data?.is_kapt_payment_window_open ?? false;
  const kaPtWindowOpenDay = complianceActionsQueryResponse?.data?.ka_pt_window_open_day ?? 1;
  const isRunPayrollActionCompleted = actionsApiResponse
    ? runPayrollActionCompletedStatuses.includes(
        actionsApiResponse[complianceActionsMap.runPayroll].status,
      )
    : false;

  return {
    complianceActionsQueryResponse,
    actionsApiResponse,
    isKaptPaymentWindowOpen,
    kaPtWindowOpenDay,
    status: complianceActionsQueryResponse.status,
    isRunPayrollActionCompleted,
  };
};
